import request from '@/utils/request'

export function getDistrict() {
  return request({
    url: '/wwqb/dict/area-tree',
    method: 'get'
  })
}

export function getQuestionSource() {
  return request({
    url: '/wwqb/dict/book-type/combo-box',
    method: 'get'
  })
}

export function addOrEditDistrict(data){
  return request({
    url: '/wwqb/home/region/edit',
    method: 'post',
    data: data
  })
}

export function searchQuestion(data){
  let url = '/wwqb/home/region/list?';
  if(data.areaId){
    url = url + '&areaId=' + data.areaId;
  }
  if(data.bookType){
    url = url + '&bookType=' + data.bookType;
  }
  if(data.year){
    url = url + '&year=' + data.year;
  }
  if(data.catalogType){
    url = url + '&catalogType=' + data.catalogType;
  }
  return request({
    url: url,
    method: 'get',
  })
}

export function updateDistrictStatus(data){
  return request({
    url: '/wwqb/home/region/status/switch',
    method: 'post',
    data: data
  })
}

export function updateBookStatus(data){
  return request({
    url: '/wwqb/home/book/status/switch',
    method: 'post',
    data: data
  })
}
export function deleteBook(data){
  return request({
    url: '/stage5/wwqb/home/book/del?bookId='+data.bookId,
    method: 'delete'
  })
}

export function deleteRegion(data){
  return request({
    url: '/stage5/wwqb/home/region/del?regionId='+data.regionId,
    method: 'delete'
  })
}

export function updateCatalogStatus(data){
  return request({
    url: '/wwqb/home/catalog/status/switch',
    method: 'post',
    data: data
  })
}

export function addOrEditQuestion(data){
  return request({
    url: '/wwqb/home/book/edit',
    method: 'post',
    data: data
  })
}

export function getAllModule(){
  return request({
    url: '/stage5/wwqb/home/catalog/all/get',
    method: 'get'
  })
}


// export function getQuestionSource(data) {
//   return request({
//     url: '/wwqb/home/book/detail?id=' + data.id,
//     method: 'get'
//   })
// }

// 查询模块列表
export function getModuleData() {
  return request({
    url: `/stage5/wwqb/home/catalog/combo-box`,
    method: 'get'
  })
}

export function getGradeAndVersion() {
  return request({
      url: `/wwqb/dict/getGradeAndVersion`,
      method: 'get',
  })
}